import DashShell from "@components/common/DashShell";
import { SectionBanner, SpinnerLoader } from "@ucchub/ui";
import manageAccessBanner from "@img/manageAccessBanner.png";
import { useEffect } from "react";
import environment from "environment";

const Support = () => {
  useEffect(() => {
    // redirect to support website domain
    window.location.href = environment.supportSiteUrl;
  }, []);

  return (
    <DashShell>
      <SectionBanner
        id="topBanner"
        heading="Support"
        iconName="book"
        image={manageAccessBanner}
      />
      <SpinnerLoader text="" />
    </DashShell>
  );
};

export default Support;
